import { useCallback, useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'

import {
  Language,
  LanguageType,
  Requirement,
  RequirementType,
} from '../../constants'

function getValue(key: string, defaultValue: string) {
  const searchParams = new URLSearchParams(window.location.search)
  const searchValue = searchParams.get(key)
  if (searchValue) {
    localStorage.setItem(key, searchValue)
    return searchValue
  }

  const localValue = localStorage.getItem(key)
  if (localValue) {
    return localValue
  }

  return defaultValue
}

export function useRouteParams() {
  return useParams()
}

export const useContact = () => {
  const [language, setLanguage] = useState<LanguageType>(
    getValue('language', Language.Japanese) as LanguageType
  )

  const [requirement, setRequirement] = useState<RequirementType>(
    getValue('requirement', Requirement.Other) as RequirementType
  )

  useEffect(() => {
    localStorage.setItem('language', language)
    localStorage.setItem('requirement', requirement)
  }, [language, requirement])

  const resetContact = useCallback(() => {
    setLanguage(Language.Japanese)
    setRequirement(Requirement.Other)
    localStorage.setItem('language', Language.Japanese)
    localStorage.setItem('requirement', Requirement.Other)
  }, [])

  return {
    requirement,
    setRequirement,
    language,
    setLanguage,
    resetContact,
  }
}
